export default function usingIE (windowOverride = window) {
  const ua = windowOverride.navigator.userAgent

  const edge = ua.indexOf('Edge/')
  const ie11 = ua.indexOf('Trident/')
  const ie10 = ua.indexOf('MSIE ')

  return edge > -1 || ie11 > -1 || ie10 > -1
}